import React from "react";

import "./style.scss";
import { H3 } from "../../AbstractElements";

interface CompletionStatusProps {
  label?: string;
  percentage: number;
  statusColor?: any;
}

const CompletionStatus: React.FC<CompletionStatusProps> = ({
  label = "Completed",
  percentage,
  statusColor = "green",
}) => {
  return (
    <div className="completion-status">
      <div className="label">{label}</div>
      <div className="d-flex gap-2">
        <div className={`status-indicator mt-2 ${statusColor}`} />
        <H3 className="fw-bold mt-1">{percentage}%</H3>
      </div>
    </div>
  );
};

export default CompletionStatus;
